import "core-js/modules/esnext.set.difference.v2.js";
import "core-js/modules/esnext.set.intersection.v2.js";
import "core-js/modules/esnext.set.is-disjoint-from.v2.js";
import "core-js/modules/esnext.set.is-subset-of.v2.js";
import "core-js/modules/esnext.set.is-superset-of.v2.js";
import "core-js/modules/esnext.set.symmetric-difference.v2.js";
import "core-js/modules/esnext.set.union.v2.js";
import { defineComponent, openBlock, createBlock, unref, withCtx, renderSlot, createVNode, createElementBlock, Fragment, renderList, toDisplayString, createCommentVNode } from "vue";
import GenericDropdown from "../../GenericDropdown/GenericDropdown.mjs";
import ClientOnly from "../../ClientOnly/ClientOnly.mjs";
const _hoisted_1 = ["label"];
const _hoisted_2 = ["data-skus-size", "value", "selected", "disabled"];
const _hoisted_3 = {
  key: 1,
  label: "Unavailable"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxSizeDropdown",
  props: {
    available: {},
    error: {
      type: Boolean
    },
    label: {},
    link: {
      default: () => ({})
    },
    selectedSize: {
      default: ""
    },
    selectId: {},
    skusForSize: {},
    unavailable: {
      default: () => []
    },
    unavailableForAllSizes: {
      default: () => /* @__PURE__ */ new Set([])
    },
    enableSoldOutSizes: {
      type: Boolean,
      default: false
    }
  },
  emits: ["registerRef", "update"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const handleSizeChange = (e) => {
      var _a;
      const newOption = e.target.value !== "-1" ? props.available[Number((_a = e.target) == null ? void 0 : _a.value)] : "";
      emit("update", newOption);
    };
    const handleRef = (ref) => {
      emit("registerRef", {
        type: "size",
        value: ref
      });
    };
    const soldOutMessage = (size) => {
      if (!props.enableSoldOutSizes) return "";
      let message = " ---- Sold Out";
      if (!props.unavailableForAllSizes.has(size)) message += " in this Color";
      return message;
    };
    const isUnavailable = (size) => props.unavailable.includes(size) || props.unavailableForAllSizes.has(size);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(GenericDropdown), {
        "select-id": "size-dropdown",
        label: _ctx.label,
        error: _ctx.error,
        "default-selected": !_ctx.selectedSize,
        onUpdate: handleSizeChange,
        onEmitRef: _cache[0] || (_cache[0] = (ref) => handleRef(ref))
      }, {
        subtitle: withCtx(() => [renderSlot(_ctx.$slots, "subtitle")]),
        link: withCtx(() => [renderSlot(_ctx.$slots, "link")]),
        default: withCtx(() => [createVNode(unref(ClientOnly), null, {
          default: withCtx(() => [_ctx.available.length > 0 ? (openBlock(), createElementBlock("optgroup", {
            key: 0,
            label: _ctx.enableSoldOutSizes ? "" : "Available"
          }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.available, (opt, index) => {
            return openBlock(), createElementBlock("option", {
              key: opt,
              "data-skus-size": _ctx.skusForSize[opt],
              value: index,
              selected: _ctx.selectedSize === opt,
              disabled: isUnavailable(opt) && _ctx.enableSoldOutSizes
            }, toDisplayString(opt + `${isUnavailable(opt) ? soldOutMessage(opt) : ""}`), 9, _hoisted_2);
          }), 128))], 8, _hoisted_1)) : createCommentVNode("", true), _ctx.unavailable.length > 0 && !_ctx.enableSoldOutSizes ? (openBlock(), createElementBlock("optgroup", _hoisted_3, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.unavailable, (opt) => {
            return openBlock(), createElementBlock("option", {
              key: opt,
              disabled: ""
            }, toDisplayString(opt), 1);
          }), 128))])) : createCommentVNode("", true)]),
          _: 1
        })]),
        _: 3
      }, 8, ["label", "error", "default-selected"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxSizeDropdown.mjs.map
